var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const LOGGER_MESSAGE_TYPE_COLORS_MAP = {
  info: "color: white; background-color: #2274A5",
  success: "color: white; background-color: #95B46A",
  error: "color: white; background-color: #D33F49"
};
const DEFAULT_LOGGER_OPTIONS = {
  isEnabled: true
};
class Logger {
  constructor(space, options) {
    __publicField(this, "_space");
    __publicField(this, "_options");
    __publicField(this, "displayLogs", (items) => {
      items.forEach(({ type, message, items: items2 }) => {
        const isExistItems = !!items2;
        const resolvedMessage = type ? [`%c ${message} `, LOGGER_MESSAGE_TYPE_COLORS_MAP[type]] : [message];
        if (isExistItems) {
          console.group(...resolvedMessage);
          this.displayLogs(items2);
          console.groupEnd();
        } else {
          console.log(...resolvedMessage);
        }
      });
    });
    __publicField(this, "log", (items) => {
      const { isEnabled } = this._options;
      if (!isEnabled) {
        return;
      }
      console.group(this._space);
      this.displayLogs(items);
      console.groupEnd();
    });
    this._space = space;
    this._options = {
      ...DEFAULT_LOGGER_OPTIONS,
      ...options
    };
  }
}
export {
  Logger
};
